import { flattenCmi, padScormTime, parseScormTime } from './utils';

export class BaseRuntime {
  constructor({ version, onCommit, onTerminate }) {
    this.version = version;
    this.onCommit = onCommit;
    this.onTerminate = onTerminate;
    this.initialized = false;
    this.terminated = false;
    this.sessionStart = Date.now();
    this.previousTotalSeconds = 0;
    this.cmi = {};
    this.errorCode = '0';
  }

  beginCommunication() {
    if (this.terminated) {
      this.terminated = false;
      this.initialized = false;
      this.errorCode = '0';
    }
    if (this.initialized) {
      this.errorCode = '0';
      return 'true';
    }
    this.initialized = true;
    this.sessionStart = Date.now();
    this.errorCode = '0';
    return 'true';
  }

  hydrateFromProgress(progress) {
    if (!progress) return;
    if (progress.timeSpent) {
      this.previousTotalSeconds = parseInt(progress.timeSpent, 10) || 0;
    } else if (progress.totalTime) {
      this.previousTotalSeconds = parseScormTime(progress.totalTime);
    }
    // Storyline 3.125+quiz: no reanudar sobre Resultados.
    if (progress.freshAttempt) {
      this.set('cmi.core.entry', 'ab-initio');
      this.set('cmi.entry', 'ab-initio');
      if (progress.totalTime) {
        this.set('cmi.core.total_time', String(progress.totalTime));
        this.set('cmi.total_time', String(progress.totalTime));
      }
      return;
    }
    if (progress.dataModel && progress.dataModel.cmi) {
      this.cmi = flattenCmi(progress.dataModel);
    }
    const map = {
      'cmi.core.lesson_status': progress.completionStatus,
      'cmi.completion_status': progress.completionStatus,
      'cmi.core.lesson_location': progress.location,
      'cmi.location': progress.location,
      'cmi.suspend_data': progress.suspendData,
      'cmi.core.score.raw': progress.scoreRaw,
      'cmi.score.raw': progress.scoreRaw,
      'cmi.core.total_time': progress.totalTime,
      'cmi.total_time': progress.totalTime,
      'cmi.core.entry': progress.entry,
      'cmi.entry': progress.entry,
      'cmi.core.exit': progress.exit,
      'cmi.exit': progress.exit,
      'cmi.success_status': progress.successStatus,
    };
    Object.keys(map).forEach((k) => {
      if (map[k] !== undefined && map[k] !== null && map[k] !== '') {
        this.cmi[k] = String(map[k]);
      }
    });
    if (progress.suspendData) {
      this.set('cmi.core.entry', 'resume');
      this.set('cmi.entry', 'resume');
    }
  }

  get(key) {
    return this.cmi[key] == null ? '' : String(this.cmi[key]);
  }

  set(key, value) {
    this.cmi[key] = value == null ? '' : String(value);
    return 'true';
  }

  sessionSeconds() {
    return Math.floor((Date.now() - this.sessionStart) / 1000);
  }

  buildCommitPayload() {
    const sessionSeconds = this.sessionSeconds();
    const totalSeconds = this.previousTotalSeconds + sessionSeconds;
    const totalTime = padScormTime(totalSeconds);
    this.set('cmi.core.total_time', totalTime);
    this.set('cmi.total_time', totalTime);
    this.set('cmi.core.session_time', padScormTime(sessionSeconds));
    this.set('cmi.session_time', padScormTime(sessionSeconds));

    const scoreRaw = this.get('cmi.core.score.raw') || this.get('cmi.score.raw');
    return {
      status: {
        completionStatus: this.get('cmi.core.lesson_status') || this.get('cmi.completion_status'),
        successStatus: this.get('cmi.core.lesson_status') === 'passed' ? 'passed'
          : this.get('cmi.core.lesson_status') === 'failed' ? 'failed'
          : this.get('cmi.success_status'),
        score: {
          raw: scoreRaw !== '' ? parseFloat(scoreRaw) : null,
          min: parseFloat(this.get('cmi.core.score.min') || this.get('cmi.score.min')) || 0,
          max: parseFloat(this.get('cmi.core.score.max') || this.get('cmi.score.max')) || 100,
          scaled: parseFloat(this.get('cmi.score.scaled')) || null,
        },
        location: this.get('cmi.core.lesson_location') || this.get('cmi.location'),
        suspendData: this.get('cmi.suspend_data'),
        totalTime,
        sessionTime: padScormTime(sessionSeconds),
        entry: this.get('cmi.core.entry') || this.get('cmi.entry'),
        exit: this.get('cmi.core.exit') || this.get('cmi.exit'),
      },
      totalSeconds,
      sessionSeconds,
      dataModel: { cmi: this.unflattenForApi() },
      realScoreCaptured: scoreRaw !== '' ? parseFloat(scoreRaw) : null,
    };
  }

  unflattenForApi() {
    const cmi = {};
    Object.keys(this.cmi).forEach((path) => {
      const parts = path.replace(/^cmi\./, '').split('.');
      let node = cmi;
      for (let i = 0; i < parts.length - 1; i++) {
        if (!node[parts[i]]) node[parts[i]] = {};
        node = node[parts[i]];
      }
      node[parts[parts.length - 1]] = this.cmi[path];
    });
    return cmi;
  }

  commit() {
    if (typeof this.onCommit === 'function') {
      this.onCommit(this.buildCommitPayload());
    }
    return 'true';
  }

  finish() {
    if (this.terminated) return 'true';
    this.terminated = true;
    const payload = this.buildCommitPayload();
    if (typeof this.onTerminate === 'function') {
      this.onTerminate(payload);
    }
    return 'true';
  }
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/scorm/frontend/runtime/BaseRuntime.js